const en = {
  message: {
    Save_cmd: 'Save',
    Close_cmd: 'Close',
    Del_cmd: 'Delete',
    Query_cmd: 'Query',
    Send_cmd: 'Send',
    Sign_in: 'Sign in',
    Sign_Out: 'Sign out',
    Lang_txt: 'Language',
    Confirm_txt: 'OK',
    Load_txt: 'Loading',
    Error_txt: 'Error',
    Success_txt: 'Success',
    Warning_txt: 'Warning',
    Info_txt: 'Info',
    Upload_txt: 'Upload',
    Back_txt: 'Back',
    Next_txt: 'Next',
    Keep_txt: 'Keep',
    Check_txt: 'Check',
    Report_txt: 'Report',
    Excel_txt: 'Excel',
    Edit_txt: 'Edit',
    Calc_txt: 'CALC',
    Anno_txt: 'Announcements',
    Cancel_txt: 'Cancel',
    DateTime_txt: 'Choose date and time',
    New_txt: 'Create',
    Contacts_txt: 'Contacts',
    NCUT_txt: 'NCUT',
    ID_txt: 'ID',
    PassW_txt: 'Password',
    ValiC_txt: 'Validate Code',
    ID_txt: '帳號',
    PassW_txt: '密碼',
    ValiC_txt: '驗證碼'
  }
}
export default en
